import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './CustomHeader.css';
import companyLogoWhite from '../company_logo_img.png';
import companyLogoRed from '../company_logo2_img.png';
import { addMobileDetectionListener } from '../utils/deviceDetection';

const menu = [
  {
    label: '오픈소스',
    path: '/opensource',
    dropdown: [
      { name: 'Linux OS', path: '/opensource?category=linux-os' },
      { name: 'WEB/WAS', path: '/opensource?category=web-was' },
      { name: 'DBMS', path: '/opensource?category=dbms' }
    ],
  },
  {
    label: '인프라솔루션',
    path: '/solutions',
    dropdown: [
      { name: 'LENA', path: '/solutions?category=lena' },
      { name: 'RedHat', path: '/solutions?category=redhat' },
      { name: 'Resin', path: '/solutions?category=resin' },
      { name: 'AgensSQL', path: '/solutions?category=agenssql' },
      { name: 'Oracle/Tibero', path: '/solutions?category=oracletibero' },
      { name: 'ClusterPlex', path: '/solutions?category=clusterplex' }
    ],
  },

  {
    label: '보안솔루션',
    path: '/security',
    dropdown: [
      { name: "UCLM", path: '/security?category=uclm' },
      { name: "D'Guard", path: '/security?category=dguard' },
      { name: "D'Guard EYE", path: '/security?category=dguard-eye' },
      { name: 'LOGuard', path: '/security?category=loguard' },
    ],
  },

  {
    label: '모니터링',
    path: '/monitoring',
    dropdown: [
      { name: 'Jennifer', path: '/monitoring?category=jennifer' },
      { name: 'MaxGauge', path: '/monitoring?category=maxgauge' },
      { name: 'TAMIS', path: '/monitoring?category=tamis' },
      { name: 'eG Enterprise', path: '/monitoring?category=eg-enterprise' },
      { name: 'OWLens', path: '/monitoring?category=owlens' }
    ],
  },
  {
    label: '기술서비스',
    path: '/support',
    dropdown: [
      { name: '케어팩서비스', path: '/support?category=carepack' },
      { name: 'DBMS컨설팅', path: '/support?category=dbms-consulting' }
    ],
  },
  
  {
  label: '다운로드',
  path: '/down',
  dropdown: [
    { name: '기술지원 프로그램', path: '/down' }
  ],
  },
];


function CustomHeader() {
  const location = useLocation();
  const [openIndex, setOpenIndex] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
      setIsScrolled(scrollTop > 50);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    const cleanupMobileListener = addMobileDetectionListener(setIsMobile);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      cleanupMobileListener();
    };
  }, [location.pathname]);

  // 모바일 메뉴 토글
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setIsMobileDropdownOpen(null); // 메뉴 토글 시 드롭다운 초기화
  };

  // 모바일 드롭다운 토글
  const toggleMobileDropdown = (index) => {
    setIsMobileDropdownOpen(isMobileDropdownOpen === index ? null : index);
  };

  // 모바일 메뉴 닫기 (링크 클릭 시)
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsMobileDropdownOpen(null);
  };

  // 홈페이지로 이동하면서 스크롤 최상단으로 이동
  const goToHomeWithScrollTop = () => {
    closeMobileMenu();
    window.scrollTo(0, 0);
  };

  // 어두운 히어로 배경 위에 헤더가 올라간 경우에만 흰색 로고
  // (스크롤 후 흰 헤더, 모바일 서브페이지 흰 헤더 등) 그 외는 빨간색
  const isOverDarkHero = !isScrolled && !(isMobile && !isHomePage);
  const logoSrc = isOverDarkHero ? companyLogoWhite : companyLogoRed;

  return (
    <nav className={`custom-header-nav ${isScrolled ? 'scrolled' : ''} ${isMobile ? 'mobile-device' : ''} ${isHomePage ? 'home-page' : ''}`}>
      <div className="nav-left">
        <div className="logo">
          <Link to="/" onClick={goToHomeWithScrollTop}>
            <img 
              src={logoSrc} 
              alt="제스트정보기술 로고" 
              className="logo-image" 
            />
          </Link>
        </div>
      </div>

      {/* 중앙 네비게이션 영역 - 모바일에서는 완전히 숨김 */}
      {!isMobile && (
        <div className="nav-center">
          <ul className="nav-links dropdown-links">
            {menu.map((item, idx) => (
              <li
                className={`dropdown-wrapper${openIndex === idx ? ' hover' : ''}`}
                key={item.label}
                onMouseEnter={() => setOpenIndex(idx)}
                onMouseLeave={() => setOpenIndex(null)}
              >
                <Link to={item.path}>{item.label}</Link>
                <div className="dropdown">
                  {item.dropdown.map((sub, i) => (
                    <Link to={sub.path} key={i}>{sub.name}</Link>
                  ))}
                </div>
              </li>
            ))}
          </ul>
          <ul className="nav-links regular-links">
            <li>
              <a href="https://blog.naver.com/xestinf" target="_blank" rel="noopener noreferrer">기술블로그</a>
            </li>
            <li>
              <Link to="/about">회사소개</Link>
            </li>
          </ul>
        </div>
      )}

      {/* 모바일 햄버거 버튼 - 모바일에서만 표시 */}
      {isMobile && (
        <button 
          className="mobile-menu-btn"
          onClick={toggleMobileMenu}
          aria-label="메뉴 열기/닫기"
        >
          <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
        </button>
      )}

      {/* 모바일 메뉴 - 모바일에서만 표시 */}
      {isMobile && (
        <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <div className="mobile-menu-content">
            {menu.map((item, idx) => (
              <div key={item.label} className="mobile-menu-item">
                <div 
                  className="mobile-menu-link"
                  onClick={() => {
                    if (isMobileDropdownOpen !== idx) {
                      // 하위 메뉴가 닫혀 있으면 펼치기만 하고 이동하지 않음
                      toggleMobileDropdown(idx);
                    } else {
                      // 이미 열려 있으면 페이지 이동
                      closeMobileMenu();
                      window.location.href = item.path;
                    }
                  }}
                >
                  <span>{item.label}</span>
                  <button 
                    className={`mobile-dropdown-btn ${isMobileDropdownOpen === idx ? 'active' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      toggleMobileDropdown(idx);
                    }}
                  >
                    ▼
                  </button>
                </div>
                <div className={`mobile-dropdown ${isMobileDropdownOpen === idx ? 'active' : ''}`}>
                  {item.dropdown.map((sub, i) => (
                    <Link 
                      to={sub.path} 
                      key={i} 
                      onClick={closeMobileMenu}
                      className="mobile-dropdown-link"
                    >
                      {sub.name}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
            
            {/* 모바일 메뉴 하단 링크들 */}
            <div className="mobile-menu-bottom">
              <a 
                href="https://blog.naver.com/xestinf" 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={closeMobileMenu}
              >
                기술블로그
              </a>
              <Link to="/about" onClick={closeMobileMenu}>회사소개</Link>
            </div>
          </div>
        </div>
      )}

      {/* 모바일 메뉴 오버레이 - 모바일에서만 표시 */}
      {isMobile && isMobileMenuOpen && (
        <div 
          className="mobile-menu-overlay"
          onClick={closeMobileMenu}
        ></div>
      )}
    </nav>
  );
}

export default CustomHeader; 
